var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { ContactMethod } from "healthex-common/consentconfig.dtos";
import { NOT_LOADED } from "../Infra/RemoteData";
import { willNeverHappen } from "healthex-common/utils";
export class PatientContactsUIManager {
    constructor(authManager, consentConfigManager, patientPreferencesManager) {
        this.authManager = authManager;
        this.consentConfigManager = consentConfigManager;
        this.patientPreferencesManager = patientPreferencesManager;
    }
    get patientEmail() {
        return this.authManager.email;
    }
    get patientPhone() {
        return this.authManager.formattedPhone;
    }
    get patientPreferencePreferredContactMethod() {
        if (this.patientPreferencesManager.preferences.value === NOT_LOADED) {
            return NOT_LOADED;
        }
        if (this.patientPreferencesManager.preferences.value === null) {
            return null;
        }
        return this.patientPreferencesManager.preferences.value.preferredContactMethod;
    }
    get healthExPreferredContactMethod() {
        var _a;
        const consentConfig = this.consentConfigManager.consentConfig.value;
        if (consentConfig === NOT_LOADED) {
            return NOT_LOADED;
        }
        if (consentConfig === null) {
            return null;
        }
        return (_a = consentConfig.healthExPreferredContactMethod) !== null && _a !== void 0 ? _a : null;
    }
    get preferredContactMethod() {
        var _a, _b;
        if (this.patientPreferencePreferredContactMethod === NOT_LOADED)
            return NOT_LOADED;
        if (this.healthExPreferredContactMethod === NOT_LOADED)
            return NOT_LOADED;
        const preferredContactMethod = (_a = this.patientPreferencePreferredContactMethod) !== null && _a !== void 0 ? _a : this.healthExPreferredContactMethod;
        if (preferredContactMethod) {
            return this.isContactMethodAvailable(preferredContactMethod) ? preferredContactMethod : null;
        }
        else {
            return ((_b = [ContactMethod.EMAIL, ContactMethod.TEXT, ContactMethod.CALL].find((contactMethod) => this.isContactMethodAvailable(contactMethod))) !== null && _b !== void 0 ? _b : null);
        }
    }
    isContactMethodAvailable(contactMethod) {
        switch (contactMethod) {
            case ContactMethod.CALL:
                return !!this.authManager.phone;
            case ContactMethod.TEXT:
                return !!this.authManager.phone;
            case ContactMethod.EMAIL:
                return !!this.authManager.email;
            case ContactMethod.DO_NOT_CONTACT:
                return true;
            case null:
                return false;
        }
        return willNeverHappen(contactMethod);
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientContactsUIManager.prototype, "patientEmail", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientContactsUIManager.prototype, "patientPhone", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientContactsUIManager.prototype, "patientPreferencePreferredContactMethod", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientContactsUIManager.prototype, "healthExPreferredContactMethod", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientContactsUIManager.prototype, "preferredContactMethod", null);
